module.exports = __webpack_public_path__ + "static/media/LogoBlanco.f89b0ba5.png";